import { ImageRatioEnum, IPushCardWithLayout, PositionEnum, ThemesEnum } from '@seb/web-design-system/core';
import { IMiniPushCard } from '@seb/web-design-system/mini-push-card';

import { richParagraphSkeleton, richParagraphSkeletonWithLinks } from '../../models/skeleton/rich-paragraph.skeleton';

export const pushCardWithLayoutSkeleton: IPushCardWithLayout = {
  push: {
    media: {},
    richParagraph: richParagraphSkeleton
  },
  mediaConfig: PositionEnum.default,
  mediaAsBackground: true,
  themesConfig: ThemesEnum.light,
  imageRatio: ImageRatioEnum.r16_9
};

export const miniPushCardSkeleton: IMiniPushCard = {
  media: {},
  richParagraph: richParagraphSkeletonWithLinks
};
